module.exports = __webpack_public_path__ + "static/media/cat-1.6fddb511.png";